:host {
  display: block;
  overflow: hidden;
}
